import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import "./App.css";
// components
import Layout from "./Components/Layout/Layout";
import ForgetPassword from "./Components/Pages/Settings/ForgetPassword/ForgetPassword";
import Login from "./Components/Pages/Login/Login";

// context
import { useUserContext } from "./context/UserContext";

function App() {
  const { store } = useUserContext();

  return (
    <BrowserRouter>
      <div className="App">
        <Switch>
          <Route path="/" exact component={Login} />
          <Route
            path="/admin/forget-password"
            exact
            component={ForgetPassword}
          />
          <Route path="/admin/login" component={Login} />
          <Route path="/admin">
            <Layout />
          </Route>
        </Switch>
      </div>
    </BrowserRouter>
  );

  // HOC for Auth routes
  function PrivateRoute({ children, ...rest }) {
    return (
      <Route
        {...rest}
        render={() =>
          store.isAuthenticated ? children : <Redirect to="/admin/login" />
        }
      />
    );
  }
}

export default App;
